export default "assets/images/icons/menu-arrow-b5c1e1db.svg";